import React from 'react';

interface TableProps {
  className?: string;
  children: React.ReactNode;
}

export function Table({ className = '', children }: TableProps) {
  return (
    <div className="scrollbar-thin overflow-x-auto">
      <table className={`min-w-full divide-y divide-gray-100 dark:divide-gray-700/60 ${className}`}>
        {children}
      </table>
    </div>
  );
}

export function TableHeader({ children }: { children: React.ReactNode }) {
  return <thead className="bg-gray-50/70 dark:bg-gray-900/30">{children}</thead>;
}

export function TableBody({ children }: { children: React.ReactNode }) {
  return (
    <tbody className="divide-y divide-gray-100 bg-white dark:divide-gray-700/60 dark:bg-transparent">
      {children}
    </tbody>
  );
}

export function TableRow({
  children,
  className = '',
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <tr
      className={`transition-colors hover:bg-gray-50/80 dark:hover:bg-gray-700/40 ${className}`}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

export function TableHead({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <th
      className={`px-3 py-3 text-left text-[0.65rem] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500 sm:px-5 ${className}`}
    >
      {children}
    </th>
  );
}

export function TableCell({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <td
      className={`whitespace-nowrap px-3 py-3 text-sm text-gray-700 dark:text-gray-200 sm:px-5 sm:py-3.5 ${className}`}
    >
      {children}
    </td>
  );
}
